import React from "react";
import clsx from "clsx";
import classes from "./styles.module.scss";

type ChipType = "success" | "warning";

interface ChipProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: ChipType;
  className?: string;
  children: React.ReactNode;
  size?: "sm" | "md";
}

export const Chip: React.FC<ChipProps> = ({
  type = "success",
  className,
  children,
  size = "sm",
  ...rest
}) => {
  return (
    <div
      className={clsx(classes.chip, classes[type], classes[size], className)}
      {...rest}
    >
      {children}
    </div>
  );
};


